import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Flex } from 'foundations-components/components/Flex';
import { BackButton } from 'foundations-components/transitional/components/BackButton';
import { Link } from 'foundations-components/transitional/components/Link';
import { Breadcrumbs } from 'foundations-components/transitional/components/Breadcrumbs';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useIsMobileView } from '../../hooks/useWindowSize';
import { ROUTES } from '../Routes';
import { trackPageView } from '../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function IframeLayout({
  children,
  backButtonMessage,
  breadcrumbs,
  subscreen
}) {
  const history = useHistory();
  const isMobileView = useIsMobileView();
  useEffect(() => {
    trackPageView(subscreen);
  }, [subscreen]);
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "300",
    paddingInline: isMobileView ? '500' : '1400',
    paddingBlockStart: isMobileView ? '700' : '500',
    children: [/*#__PURE__*/_jsx(BackButton, {
      children: /*#__PURE__*/_jsx(Link, {
        onClick: () => history.push(ROUTES.billing),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: backButtonMessage
        })
      })
    }), /*#__PURE__*/_jsx(Breadcrumbs, {
      paddingInline: isMobileView ? '800' : '1300',
      flush: false,
      gap: "400",
      children: breadcrumbs.map((breadcrumb, index) => {
        const isLast = index === breadcrumbs.length - 1;
        return isLast ? /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: breadcrumb.label
          })
        }, index) : /*#__PURE__*/_jsx(Link, {
          href: breadcrumb.href || ROUTES.billing,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: breadcrumb.label
          })
        }, index);
      })
    }), children]
  });
}